import React, {Component, Fragment} from 'react';
import {Form} from 'reactstrap';
import CheckoffResponse from './CheckoffResponse';
import CommentResponse from './CommentResponse';
import DatetimeResponse from './DatetimeResponse';
import RatingResponse from './RatingResponse';
import RatingMultiResponse from './RatingMultiResponse';
import SignatureResponse from './SignatureResponse';
import TextResponse from './TextResponse';
import './DynamicForm.scss';
import RatingSimple from "./RatingSimple";
import notificationsActionsCreator from "../../../store/notifications/action-creators";
import RemedialTrainingResponse from "./RemedialTrainingResponse";
import CallTrackingResponse from "./CallTrackingResponse";
import DailyPatrolLogResponse from "./DailyPatrolLogResponse";
import LogFieldResponse from "./LogFieldResponse";
import QuestionFieldResponse from "./QuestionFieldResponse";
import PtoRatingMultiResponse from "./PtoRatingMultiResponse";
import TimeTrackingField from "./TimeTrackingField";
import PbleField from "./PbleField";
import EvaluationRatingResponse from "./EvaluationRatingResponse";


// eslint-disable-next-line arrow-body-style
class DynamicForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      responses: {
        ...this.parseResponsesFromProps(
          this.props.layout,
          this.props.responses,
          {},
        ),
      },
      responsesPending: {},
      signature: {
        isChecked: false,
        signedAt: null,
      },
      showSubmitError: false,
    };


  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(JSON.stringify(this.props.responses) !== JSON.stringify(prevProps.responses)) {
      console.log('this.props.overrideResponses', this.props.overrideResponses)
      if(this.props.overrideResponses) {
        this.setState({
          responses: {
            ...this.overrideResponsesFromProps(
              this.props.layout,
              this.props.responses,
              this.state.responses
            ),
          },
          responsesPending: {}
        })
      } else {
        this.setState({
          responses: {
            ...this.parseResponsesFromProps(
              this.props.layout,
              this.props.responses,
              this.state.responses
            ),
          },
          responsesPending: {}
        })
      }
    }
  }

  autoSaveTimeOut = null;

  componentWillUnmount() {
    clearTimeout(this.autoSaveTimeOut);
  }

  showCannotSubmitMessage() {
    this.setState({
      showSubmitError: true
    });
    // setTimeout(() => {
    //   this.setState({
    //     showSubmitError: false
    //   });
    // }, 5000)
    // this.props.notifyError('You must rate all of the questions before you can submit the form')
  }
  // ----------------------
  // Computed
  // ----------------------

  get canSubmit() {
    return this.isValid && this.props.hasValidShift && this.state.signature.isChecked;
  }

  get isValid() {
    const valid = !Object.keys(this.state.responses).find(key => {
      return (!this.state.responses[key].isValid)
    });
    return valid;
  }

  get invalidQuestions() {
    return this.props.layout
      .filter((element, index) => (this.state.responses[index] && !this.state.responses[index].isValid))
      .map(el => {
        return el.prompt || el.ratingPrompt
      });
  }

  get dateTime() {
    let datetimeField = this.props.layout
      .find((el) => el.schema === 'datetime');
    if(datetimeField) {
      return this.getValueObject(datetimeField)
    }
  }

  // ----------------------
  // Methods
  // ----------------------

  /**
   * Reads config of a form layout question element and returns response value object
   *   with default values
   * @param {Object} element Form element config object
   * @param {number} index Integer array index
   */
  getValueObject(element) {
    switch (element.schema) {
      case 'checkoff':
        return { isChecked: false };
      case 'comment':
        return { comment: '' };
      case 'datetime':
        return !this.props.schedule
          ? { datetime: new Date().toISOString() }
          : {
            datetime: this.props.schedule.observationDate,
            isScheduled: true,
          };
      case 'rating':
        return {
          rating: 0,
          notObserved: false,
          notResponsive: false,
          comment: '',
        };
      case 'rating-multi':
        return {
          notObserved: false,
          notResponsive: false,
          rating: 0,
          comment: '',
        };
      case 'pto-rating-multi':
        return {
          notObserved: false,
          notResponsive: false,
          rating: 0,
          comment: '',
          observationComment: '',
        };
      case 'evaluation-rating':
        return {
          notObserved: false,
          notResponsive: false,
          rating: 0,
          comment: '',
          isValid: false,
        };
      case 'rating-simple':
        return {
          rating: null,
          comment: '',
        };
      case 'time-field':
        return {
          total: 0,
          segments: []
        };
      case 'text':
        return {text: ''};
      case 'remedial-training':
      case 'call-tracking':
        return {list: []};
      case 'daily-patrol-log':
        return {list: []};
      case 'log-field':
        return {list: []};
      case 'question-field':
        return {list: []};
      case 'pble':
        return {selected: null};
      default:
        throw new Error('Invalid element schema');
    }
  }

  handleInput(key, valueObject) {
    this.setState((state) => {
      return {
        ...state,
        responses: {
          ...state.responses,
          [key]: valueObject,
        },
        responsesPending: {
          ...state.responsesPending,
          [key]: valueObject,
        }
      };
    }, () => {
      if(!this.isValid) {
        this.setState({
          signature: {isChecked: false, signedAt: null}
        })
      }
      this.autoSave(key, valueObject);
    });


  }

  handleSignature(valueObject) {
    this.setState({ signature: valueObject });
  }

  autoSave(key, valueObject) {
    clearTimeout(this.autoSaveTimeOut);

    this.autoSaveTimeOut = setTimeout(() => {
      if(!this.canSubmit) {
        const formData = {
          responses: this.parseResponsesFromState({
            ...this.state.responses,
            [key]: valueObject
          }),
          signedAt: null,
        };
        this.props.onAutoSave && this.props.onAutoSave(formData);
      }
    }, 3000)
  }

  handleSubmit(event) {
    event.preventDefault();
    const formData = {
      responses: this.parseResponsesFromState(this.state.responses),
      signedAt: !this.state.signature.isChecked
        ? null
        : this.state.signature.signedAt,
    };
    this.props.onSave(formData);
  }

  /**
   * Reads the current component state and parses it into a valid responses object
   *   used to POST an API request to create a report
   * @param {Object} stateResponses Current component state
   */
  parseResponsesFromState(stateResponses) {
    const responses = Object.keys(stateResponses).reduce((accumulator, key) => {
      const valueObject = { ...stateResponses[key] };
      // Remove params used for validation in this component
      delete valueObject.isValid;
      delete valueObject.touched;
      accumulator.push({
        ...valueObject,
        sequence: key,
      });
      return accumulator;
    }, []);
    return responses;
  }

  /**
   * Reads a form layout config object and builds state shape to accumulate input
   * @param {Object} layout Form layout config object
   * @param {Object} responses Form layout config object
   * @param {Object} stateResponses Form layout config object
   */
  parseResponsesFromProps(layout, responses, stateResponses) {
    const report = layout.reduce((accumulator, element, index) => {
      if (element.type === 'header') {
        return accumulator;
      }
      Object.assign(accumulator, {
        [index]: (responses[index.toString()] || stateResponses[index.toString()])
          ? { ...responses[index.toString()], ...(stateResponses[index.toString()] || {})}
          : this.getValueObject(element),
      });
      return accumulator;
    }, {});
    return report;
  }

  /**
   * Reads a form layout config object and builds state shape to accumulate input
   * @param {Object} layout Form layout config object
   * @param {Object} responses Form layout config object
   * @param {Object} stateResponses Form layout config object
   */
  overrideResponsesFromProps(layout, responses, stateResponses) {
    const report = layout.reduce((accumulator, element, index) => {
      if (element.type === 'header') {
        return accumulator;
      }
      let response = responses[index.toString()] || stateResponses[index.toString()]
      let localResponse = stateResponses[index.toString()] || {}
      Object.assign(accumulator, {
        [index]: response
          ? {...localResponse, ...response}
          : this.getValueObject(element),
      });
      return accumulator;
    }, {});
    return report;
  }

  get isMarkReportAsNotObservedAvailable() {
    return this.props.layout.find((element, index) => this.isNotObservedAvailableForElement(element, index))
  }

  isNotObservedAvailableForElement(element, index) {
    const response = this.state.responses[index.toString()] || this.state.responses[index];
    if (!response || !response.hasOwnProperty('notObserved')) {
      return false
    }
    if (element.schema === 'evaluation-rating') {
      return element.useNotObserved !== undefined ? element.useNotObserved !== false : element.useNoNr !== false
    }
    if (element.schema === 'rating-multi') {
      return element.useNotObserved !== undefined ? element.useNotObserved !== false : element.useNoNr !== false
    }
    return true
  }

  markReportAsNotObserved() {
    this.setState({
      responses: Object.keys(this.state.responses).reduce((acc, key) => {
        if (this.isNotObservedAvailableForElement(this.props.layout[key], key)) {
          return {
            ...acc,
            [key]: {
              ...this.state.responses[key],
              rating: 0,
              notObserved: true,
              isValid: true
            }
          }
        }
        return {
          ...acc,
          [key]: this.state.responses[key]
        }
      }, {})
    })
  }

  renderElement(element, index) {
    switch (element.schema) {
      case 'checkoff':
        return (
          <CheckoffResponse
            key={index.toString()}
            name={index.toString()}
            onValueChange={(key, valueObject) =>
              this.handleInput(key, valueObject)
            }
            prompt={element.prompt}
            isNotRequired={element.isNotRequired}
            checkoffPrompt={element.checkoffPrompt}
            value={this.state.responses[index.toString()]}
          />
        );
      case 'comment':
        return (
          <CommentResponse
            key={index.toString()}
            name={index.toString()}
            onValueChange={(key, valueObject) =>
              this.handleInput(key, valueObject)
            }
            prompt={element.prompt}
            requireResponse={element.requireResponse}
            value={this.state.responses[index.toString()]}
          />
        );
      case 'datetime':
        return (
          <DatetimeResponse
            key={index.toString()}
            name={index.toString()}
            onValueChange={(key, valueObject) =>
              this.handleInput(key, valueObject)
            }
            prompt={element.prompt}
            value={this.state.responses[index.toString()]}
          />
        );
      case 'rating':
        return (
          <RatingResponse
            key={index.toString()}
            name={index.toString()}
            onValueChange={(key, valueObject) =>
              this.handleInput(key, valueObject)
            }
            prompt={element.prompt}
            scale={this.props.settings ? this.props.settings.scale : null}
            value={this.state.responses[index.toString()]}
          />
        );
      case 'rating-multi':
        return (
          <RatingMultiResponse
            key={index.toString()}
            name={index.toString()}
            onValueChange={(key, valueObject) =>
              this.handleInput(key, valueObject)
            }
            ratingPrompt={element.ratingPrompt}
            notObservedPrompt={element.notObservedPrompt}
            notResponsivePrompt={element.notResponsivePrompt}
            defaultComments={element.defaultComments}
            requiredComments={element.requiredComments}
            hasTimeSpendField={element.hasTimeSpendField}
            requiredTimeSpendRatings={element.requiredTimeSpendRatings}
            timeSpendFieldPrompt={element.timeSpendFieldPrompt}
            scoreOverrides={element.scoreOverrides}
            overrideDefaultScores={element.overrideDefaultScores}
            scale={this.props.settings ? this.props.settings.scale : null}
            value={this.state.responses[index.toString()]}
            useNoNr={element.useNoNr}
            useNotObserved={element.useNotObserved}
            useNotResponsive={element.useNotResponsive}
          />
        );
      case 'pto-rating-multi':
        return (
          <PtoRatingMultiResponse
            key={index.toString()}
            name={index.toString()}
            onValueChange={(key, valueObject) =>
              this.handleInput(key, valueObject)
            }
            ratingPrompt={element.ratingPrompt}
            notObservedPrompt={element.notObservedPrompt}
            notResponsivePrompt={element.notResponsivePrompt}
            defaultComments={element.defaultComments}
            requiredComments={element.requiredComments}
            hasTimeSpendField={element.hasTimeSpendField}
            requiredTimeSpendRatings={element.requiredTimeSpendRatings}
            timeSpendFieldPrompt={element.timeSpendFieldPrompt}
            disableOitComment={element.disableOitComment}
            scale={this.props.settings ? this.props.settings.scale : null}
            value={this.state.responses[index.toString()]}
            useNoNr={element.useNoNr}
            useNotObserved={element.useNotObserved}
            useNotResponsive={element.useNotResponsive}
          />
        );
      case 'evaluation-rating':
        return (
          <EvaluationRatingResponse
            key={index.toString()}
            name={index.toString()}
            onValueChange={(key, valueObject) =>
              this.handleInput(key, valueObject)
            }
            ratingPrompt={element.ratingPrompt}
            notObservedPrompt={element.notObservedPrompt}
            notResponsivePrompt={element.notResponsivePrompt}
            defaultComments={element.defaultComments}
            requiredComments={element.requiredComments}
            scoreOverrides={element.scoreOverrides}
            scale={element.scale || 3}
            value={this.state.responses[index.toString()]}
            useNoNr={element.useNoNr}
            useNotObserved={element.useNotObserved}
            useNotResponsive={element.useNotResponsive}
            heading="Trainee Self-Assessment"
            commentPlaceholder="Trainee notes"
          />
        );
      case 'rating-simple':

        return (
          <RatingSimple
            key={index.toString()}
            name={index.toString()}
            onValueChange={(key, valueObject) =>
              this.handleInput(key, valueObject)
            }
            ratingPrompt={element.ratingPrompt}
            acceptablePrompt={element.acceptable}
            unAcceptablePrompt={element.unAcceptable}
            useNoNr={element.useNoNr}
            useNo={element.useNo}
            notObservedPrompt={element.notObservedPrompt}
            notResponsivePrompt={element.notResponsivePrompt}
            value={this.state.responses[index.toString()]}
            hasTimeSpendField={element.hasTimeSpendField}
            timeSpendFieldPrompt={element.timeSpendFieldPrompt}
            reqiureUnacceptableComment={element.reqiureUnacceptableComment}
          />
        );
      case 'text':
        return (
          <TextResponse
            key={index.toString()}
            name={index.toString()}
            onValueChange={(key, valueObject) =>
              this.handleInput(key, valueObject)
            }
            prompt={element.prompt}
            value={this.state.responses[index.toString()]}
          />
        );

      case 'remedial-training':
        return (
          <RemedialTrainingResponse
            key={index.toString()}
            name={index.toString()}
            onValueChange={(key, valueObject) =>
              this.handleInput(key, valueObject)
            }
            value={this.state.responses[index.toString()]}
            element={element}
          />
        )

      case 'call-tracking':
        return (
          <CallTrackingResponse
            key={index.toString()}
            name={index.toString()}
            onValueChange={(key, valueObject) =>
              this.handleInput(key, valueObject)
            }
            value={this.state.responses[index.toString()]}
            element={element}
          />
        )
      case 'daily-patrol-log':
        return (
          <DailyPatrolLogResponse
            key={index.toString()}
            name={index.toString()}
            onValueChange={(key, valueObject) =>
              this.handleInput(key, valueObject)
            }
            value={this.state.responses[index.toString()]}
            element={element}
          />
        )
      case 'log-field':
        return (
          <LogFieldResponse
            onValueChange={(key, valueObject) => {
              this.handleInput(key, valueObject)
            }}
            element={element}
            name={index.toString()}
            acknowledger={this.props.acknowledger}
            datetime={this.dateTime}
            value={this.state.responses[index]}
          />
        )
      case 'question-field':
        return (
          <QuestionFieldResponse
            onValueChange={(key, valueObject) => {
              this.handleInput(key, valueObject)
            }}
            element={element}
            name={index.toString()}
            value={this.state.responses[index.toString()]}
          />
        )
      case 'time-field':
        return (
          <TimeTrackingField
            onValueChange={(key, valueObject) => {
              this.handleInput(key, valueObject)
            }}
            element={element}
            name={index.toString()}
            value={this.state.responses[index.toString()]}
            isEdit={true}
          />
        )
      case 'pble':
        return (
          <PbleField
            onValueChange={(key, valueObject) => {
              this.handleInput(key, valueObject)
            }}
            element={element}
            name={index.toString()}
            value={this.state.responses[index.toString()]}
            isEdit={true}
          />
        )
      default:
        throw new Error('Invalid element schema ' + element.schema);
    }
  }
  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Form
        className="dynamic-form"
        noValidate
      >
        {this.props.layout.map((element, index) => {
          if (element.type === 'header') {
            return (
              <div className="form-header" key={index.toString() + 'header'}>
                <legend style={{
                  whiteSpace: 'pre-line',
                  unicodeBidi: 'embed',
                  maxWidth: '100%',
                  fontSize: '1em'
                }}>{element.content}</legend>
              </div>
            );
          }

          return <div key={index.toString() + 'element'} className={this.state.showSubmitError && this.state.responses[index.toString()] && !this.state.responses[index.toString()].isValid? 'field-invalid': ''}>
            {this.renderElement(element, index)}
          </div>

        })}
        {this.isValid && (
          <SignatureResponse
            name="signature"
            onValueChange={valueObject => this.handleSignature(valueObject)}
            prompt="Sign and Date"
            value={this.state.signature}
          />
        )}

        {this.props.children}

        {this.state.showSubmitError && !this.props.hasValidShift ? (
          <div className="text-danger" style={{padding: '10px 0'}}>You must select shift before submitting the
            form</div>
        ) : null}

        {this.state.showSubmitError && !this.isValid ? (
          <div className="form-errors">
            <div className="error-header" style={{padding: '10px 0'}}>You must rate the following questions before you can submit the form</div>
            {this.invalidQuestions.map((q) => (
              <div key={q}>{q}</div>
            ))}
          </div>
        ) : null}

        {this.canSubmit ? (
          <button
            className="button primary"
            onClick={event => this.handleSubmit(event)}
          >
            Submit
          </button>
        ) : (
          <Fragment>
            <button
              className="button secondary"
              onClick={event => this.handleSubmit(event)}
            >
              Save Draft
            </button>
            <button
              className="button primary"
              style={{marginLeft: '20px'}}
              type="button"
              onClick={event => this.showCannotSubmitMessage(event)}
            >
              Submit
            </button>
            {this.isMarkReportAsNotObservedAvailable && <button
              className="button secondary"
              type="button"
              style={{marginLeft: '20px'}}
              onClick={event => this.markReportAsNotObserved(event)}
            >
              Mark report as not observed
            </button>}
          </Fragment>
        )}
      </Form>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    notifyError: (message) =>
      dispatch(notificationsActionsCreator.addError(message))
  }
}

export default DynamicForm;
